import React from 'react';

const Toolbar = (props) => {
    return <div className={"btn-toolbar"+(props.className ? " "+props.className :"")}>{props.children}</div>;
};

export default Toolbar;